import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

import { url } from '../../../config';

//Style
import { body, fontWeightBold, marginBottom, buttonStyle, center } from '../../../helpers/getEmailStyles';

class BookingRequestHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      hostName: PropTypes.string.isRequired,
      guestName: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      hostServiceFee: PropTypes.number.isRequired,
    }).isRequired

  };

  render() {
    const { content: { reservationId, hostName, guestName, checkIn, checkOut, threadId, logo, siteName } } = this.props;
    const { content: { total, hostServiceFee, guests } } = this.props;

    let checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '',
      checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';
    let actionURL = url + '/message/' + threadId + '/host',
      subtotal = total - hostServiceFee;
    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Hi {hostName},
          </div>
          <EmptySpace height={20} />
          <div>
            Great News! You have a new reservation on {siteName} from {guestName}
          </div>
          <EmptySpace height={10} />
          <div style={marginBottom}><span style={fontWeightBold}>Reservation Details:-</span></div>
          <div style={marginBottom}><span style={fontWeightBold}>Guest Name:</span> {guestName}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Check-in:</span> {checkInDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Check-out:</span> {checkOutDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Guests:</span> {guests}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Reservation ID:</span> {reservationId}</div>
          <EmptySpace height={10} />
          <div>
            Please review the details and get ready to welcome your guest!
          </div>
          <EmptySpace height={20} />
          <div style={center}>
            <a href={actionURL} style={buttonStyle}>Accept or Decline</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default BookingRequestHost;